import { cn } from '@/lib/utils';
import { CODE_BADGE_CLASS } from '@/styles/codeBadge';

const FISCAL_YEAR_PREFIX_PATTERN = /^FY\s*/i;

interface FiscalYearBadgeProps {
  fiscalYear: string;
}

export function FiscalYearBadge({ fiscalYear }: FiscalYearBadgeProps) {
  const yearRange = fiscalYear.replace(FISCAL_YEAR_PREFIX_PATTERN, '');

  return <span className={cn(CODE_BADGE_CLASS, 'mt-1 inline-block w-fit')}>FY {yearRange}</span>;
}
